import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ContactUs from './Components/ContactUs';
import Footer from './Components/Footer';
import Header from './Components/Header';
import Home from './Components/Home';
import Nav from './Components/Nav';
import SignUp from './Components/SignUp';
import Login from './Components/Login';
import ResetPassword from './Components/ResetPassword';
import { clarity } from 'react-microsoft-clarity';
import AboutUs from './Components/AboutUs';
import Subscription from './Components/Subscription';
import BootCamp from './Components/BootCamp';
import CounselingService from './Components/CounselingService';
clarity.init("qnfhgrjdpj");
clarity.consent();

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Nav />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/tutoring-service" element={<SignUp fromTutoring={true} />} />
          <Route path="/login" element={<Login />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/test-prep" element={<SignUp fromTestPrep={true} />} />
          <Route path="/edit" element={<SignUp />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/bootcamp" element={<BootCamp />} />
          <Route path="/counseling-service" element={<CounselingService />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
